import React from "react";
import { ListItem, ListItemIcon, ListItemText } from "@mui/material";

const PerfilMenuItem = ({ item, desktopOpen, isMobile, location, onClose }) => (
    <ListItem
        button
        selected={location.pathname === item.segment}
        onClick={() => {
        item.onClick();
        if (isMobile && onClose) onClose();
        }}
        sx={{
        cursor: "pointer",
        padding: desktopOpen ? "20px 16px" : "12px 8px",
        justifyContent: desktopOpen ? "flex-start" : "center",
        minHeight: "48px",
        "&.Mui-selected": {
            backgroundColor: "rgba(255,255,255,0.1)",
            "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
        },
        }}
    >
        <ListItemIcon
        sx={{
            color: "white",
            minWidth: desktopOpen ? "56px" : "auto",
            justifyContent: "center",
        }}
        >
        {item.icon}
        </ListItemIcon>
        {desktopOpen && (
        <ListItemText
            primary={item.title}
            primaryTypographyProps={{ style: { color: "white" }, noWrap: true }}
        />
        )}
    </ListItem>
);

export default PerfilMenuItem;
